// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert.alert-danger {
  padding: 3px 10px 0 0;
  font-size: 14px;
  line-height: normal;
  background: none;
  border: none;
  color: #a94442;
  text-align: left;
  width: 100%;
  display: inline-block;
  margin: 0;
}

.form-group-row {
  position: relative;
  margin-bottom: 5px;
}

.ng-invalid.ng-touched {
  border-color: #a94442;
  border-radius: 4px;
}

.disCHeck {
  display: inline-block;
}

.disclousureText {
  display: inline-block;
  padding-left: 10px;
  width: 95%;
  vertical-align: top;
}

.cardheader {
  /* height: 30px;
	width: 137px; */
  color: #000000;
  font-family: "Noto Sans";
  font-size: 22px;
  line-height: 30px;
}

.studySummary {
  word-break: break-word;
}

.cardtext {
  /* height: 30px;
	width: 137px; */
  color: #000000;
  font-family: "Noto Sans";
  vertical-align: middle;
  /* line-height: 23px; */
  margin: 0 -10px;
  word-break: break-word;
}

.apply-for-study {
  /* height: 48px;
	width: 245px; */
  color: #000000;
  font-family: "Noto Sans";
  font-size: 32px;
  font-weight: bold;
  line-height: 48px;
}

.studyViewCards .cardTitle {
  font-size: 22px;
  border-bottom: 1px solid #cee3ef;
  padding-bottom: 10px;
  padding-left: 15px;
  margin: 0 -10px;
}

.studyViewCards .card {
  border-bottom: none;
  border-radius: 5px;
  /*border: none;*/
  box-shadow: 0 0 8px 5px rgba(0,49,77,0.2);
}

/* studyViewCards .card-body {
    height: 295px; 
    padding-bottom: 10px;
} */

.screenDays {
  font-size: 36px;
  height: 15px;
  line-height: 75px;
  /* padding: 0 15px; */
}

.scheduleWrap .timeList {
  list-style: none;
  padding: 10px 15px;
  border-bottom: 1px solid #ededed;
  margin-bottom: 0;
}

.scheduleWrap .cardtext .timeList:last-child {
  border-bottom: none;
}

.scheduleWrap .dayName {
  font-size: 14px;
  text-transform: capitalize;
}

.scheduleWrap .dayTime {
  font-size: 14px;
  line-height: normal;
  color: #0885ce;
}

.scheudleDesc {
  line-height: normal;
  padding-top: 8px;
  background-color: #ededed;
  padding: 6px 15px;
  margin-bottom: 0;
  word-break: break-word;
}

.screenDay, .followDay {
  height: 35px;
  padding: 8px 10px 8px 15px;
  font-size: 14px;
  text-transform: capitalize;
}

.followDay {
  word-break: break-word;
  color: #0885ce;
}

.screenerWrap, .disclosureForm, .demoGraphicWrap {
  padding: 80px 0;
}

.demographicsForm {
  font-size: 14px;
}

  .demographicsForm .label, .demographicsForm .custom-control-label {
    font-size: 14px;
    color: #444444;
  }

.demographicsForm .custom-control-label .consent-label-html {
  color: inherit;
  font: inherit;
}

.demographicsForm .consent-group-label,
.demographicsForm .consent-group-label .consent-label-html {
  font-size: 14px;
  font-weight: normal;
  color: #444444;
}

.lsr-form-title,
.lsr-study-form .lsr-form-title {
  margin-bottom: 18px;
  text-align: center;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

.lsr-study-form .lsr-form-text {
  font-size: 14px;
  color: #444444;
}

.lsr-study-form .lsr-form-text .consent-label-html {
  color: inherit;
  font: inherit;
}

.lsr-study-form .lsr-consent-group-label,
.lsr-study-form .lsr-consent-group-label .consent-label-html {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  text-align: justify;
  color: #555555;
  gap: 8px;   
}

.lsr-study-form .lsr-required {
  display: inline-block;
  position: relative;
  top: 6px;
  margin-right: 3px;
  color: var(--color-required);
  font-size: 24px;
  line-height: 1;
  font-weight: 800;
}

.lsr-study-form .lsr-primary-button {
  color: var(--color-white);
  background: var(--color-purple);
}

.lsr-study-form .lsr-primary-button:hover,
.lsr-study-form .lsr-primary-button:focus-visible {
  color: var(--color-white);
  background: var(--color-purple);
}

.lsr-study-form .lsr-primary-button:disabled {
  color: var(--color-white) !important;
  background: var(--color-purple) !important;
  opacity: 0.5;
}

/* LSR custom checkbox appearance for tenantId === '2' */
.lsr-study-form .form-check-input[type="checkbox"] {
  width: 16px;
  height: 16px; 
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  position: relative;
  flex: 0 0 16px;
  border-radius: 3px;
  border: 1px solid var(--color-border, #bdbfc0);
  background: var(--color-white, #ffffff);
  margin-top: 8px;
}

.lsr-study-form .form-check-input[type="checkbox"]:checked {
  border-color: var(--color-green, #008073);
  background-color: var(--color-green, #008073);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px 14px;
}

.lsr-study-form .form-check-input[type="checkbox"]:checked::after {
  display: none;
}

.lsr-study-form .lsr-child-consent-row {
  padding: 5px;
}

/* LSR custom radio appearance for tenantId === '2' */
.lsr-study-form .custom-control-input[type="radio"] {
  width: 16px;
  height: 16px;
  margin: 0 6px 0 0;
  display: inline-block;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  position: relative;
  left: auto;
  opacity: 1;
  z-index: 1;
  flex: 0 0 16px;
  align-self: center;
  border-radius: 50%;
  border: 1px solid var(--color-border, #bdbfc0);
  background: var(--color-white, #ffffff);
}

.lsr-study-form .custom-control.custom-radio {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  min-height: unset;
}

.lsr-study-form .custom-control.custom-radio .custom-control-label {
  padding-left: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  min-height: unset;
}

.lsr-study-form .custom-control-input[type="radio"]:checked {
  border-color: var(--color-green, #008073);
  background: radial-gradient(circle, var(--color-green, #008073) 0 45%, var(--color-white, #ffffff) 46% 100%);
}

.lsr-study-form .custom-control-input[type="radio"]:checked::after {
  display: none;
}

/* Hide Bootstrap custom-control-label pseudo-element checkbox duplicate */
.lsr-study-form .custom-control-label::before,
.lsr-study-form .custom-control-label::after {
  display: none;
}

.lsr-study-form-title {
  margin-bottom: 18px;
  text-align: center;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

:host ::ng-deep .primary-button {
  margin-top: 10px !important;
}

:host .lsr-study-page .primary-button {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  cursor: pointer;
  padding: 16px 34px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: var(--font-main);
  font-size: 15px;
  line-height: 1;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  margin-top: 10px;
  color: var(--color-white);
  background: var(--color-green-button);
  transition: color var(--transition), background-color var(--transition), border-color var(--transition);
}

:host .lsr-study-page .primary-button:link,
:host .lsr-study-page .primary-button:visited {
  color: var(--color-white);
  text-decoration: none;
}

:host .lsr-study-page .primary-button:hover,
:host .lsr-study-page .primary-button:focus-visible {
  color: var(--color-white);
  border-color: transparent;
  background: var(--color-purple);
}

:host .lsr-study-page .primary-button:disabled {
  background: var(--color-green-button) !important;
  color: var(--color-white) !important;
  opacity: 0.5;
  cursor: not-allowed;
}

.aboutTextSec {
  padding: 30px 0;
}

/*.custWid {
    min-width: 150px;
}

 .custWid-age {
    max-width: 80px;
}
.custWei, .custHei {
    max-width: 95px;
}*/
.custWrist {
  max-width: 200px;
  padding: 0;
}

.requirements {
  padding-bottom: 40px;
}

.optionsWrap {
  margin: 0 auto;
}

.answerOptions > div {
  margin: 0 auto;
}

.maxW115 {
  max-width: 107px;
}

.bestTimeToCallWrap .custom-control.custom-checkbox {
  margin-bottom: 7px;
}

.disclosureForm .container.custom-control {
  margin-bottom: 15px;
}

.screenerWrap .optionsWrap .custom-control.custom-radio {
  margin-bottom: 7px;
}

p-calendar {
  width: 100%;
}
/* @media (min-width: 768px) {
    .perDiv {
        width: auto;
    }
} */
.detailForm label {
  margin-bottom: 1px;
  font-size: 17px;
  font-weight: bold;
}

.normalFont {
  font-weight: normal;
  color: #000000;
}

.compenHead {
  padding-bottom: 6px;
}

.invalidInput, .invalidInput:focus {
  border-color: #a94442;
}

.dobInput {
  left: 0;
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: "lnum" 1, "tnum" 1;
}

.dCircle {
  border-radius: 250px;
  display: inline-block;
  width: 85px;
  height: 85px;
  line-height: 85px;
  text-align: center;
  color: #ffffff;
}

.screening {
  background-color: #005586;
}

.dcd {
  background-color: #288cc6;
}

.followUp {
  background-color: #59baf3;
}

#commitment-table tr td {
  padding: 10px 15px;
  border-bottom: 1px solid #ededed;
}

#studySchedule-table tr td {
  border-bottom: 1px solid #ededed;
}

#commitment-table tr:last-child td, #studySchedule-table tr:last-child td {
  border-bottom: none;
}

.marg {
  margin: 0 -10px;
}

#studySchedule-table.table thead > tr > th {
  height: auto;
  padding: 8px 15px;
  background-color: #ededed;
}

.backBtn {
  border: 1px solid #d9d9d9 !important;
  height: 30px;
  width: 102px;
  background-color: #fff;
  margin-left: 15px;
  font-weight: 600;
}

.custom-checkbox {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 5px;
  border: 2px solid #000;
  background-color: #fff;
  cursor: pointer;
  position: relative;
}

.backBtn:hover {
  color: #FFFFFF;
  border: 1px solid #0094ff;
  background-color: #0094ff;
}

div[name="contact"] {
  width: 100%;
  text-align: justify;
  margin: 3px auto;
}

div[name="form-start"] {
  margin-top: 25px;
}

@media (max-width: 767px) {
  .custWrist {
    max-width: 100%;
    padding: 0 15px;
  }

  .perDiv {
    margin-bottom: 8px;
    padding-bottom: 5px;
  }

  .p-25 {
    padding: 0 25px
  }

  .genderWrap {
    margin-top: 15px;
  }

  .studyViewCards .col-sm-12 {
    padding-left: 0;
  }

  .demoGraphicWrap {
    padding: 40px 0;
  }

  .blueBox {
    padding: 40px 20px 20px;
  }
}

button[name=continueBtn]:disabled:not(.primary-button) {
  background-color: #2cb00e;
  color: #fff;
}

.listPosInside {
  list-style-type: none;
  padding-left: 0;
}

  .listPosInside li {
    list-style-type: none;
  }

.name-row .form-group {
  margin-bottom: 1rem;
}

@media (max-width: 767.98px) {
  .name-row > div {
    margin-bottom: 1.5rem;
  }
}

#txtweight {
  margin-left: 16px;
  max-width: 90%;
}

.lsr-study-form .weight-field,
.lsr-study-form .bmi-field {
  display: flex;
  flex-direction: column;  
}

.lsr-study-form .weight-field .label,
.lsr-study-form .bmi-field .label {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
}

.lsr-study-form .weight-field .form-control,
.lsr-study-form .bmi-field .form-control {
  margin-top: 0;
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: "lnum" 1, "tnum" 1;
}

/* Tenant 2 (LSR) study-page local styles */
:host .lsr-study-page {
  font-family: var(--font-main);
  color: var(--color-black);
}

:host .lsr-study-page h1,
:host .lsr-study-page h2,
:host .lsr-study-page h3,
:host .lsr-study-page p,
:host .lsr-study-page ul {
  margin: 0;
}

:host .lsr-study-page h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
}

:host .lsr-study-page h2 {
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

:host .lsr-study-page p,
:host .lsr-study-page ul {
  font-size: 18px;
  line-height: 1.18;
}

:host .lsr-study-page ul {
  max-width: 563px;
  padding-left: 24px;
}

:host .lsr-study-page li::marker {
  font-size: 10px;
}

:host .lsr-study-page a {
  color: inherit;
}

:host .lsr-study-page p a {
  color: var(--color-green);
}

:host .lsr-study-page img {
  display: block;
  max-width: 100%;
  height: auto;
  border: 0;
}

:host .lsr-study-page section {
  scroll-margin-top: 120px;
}

:host .lsr-study-page .hero {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  padding-right: 76px;
  color: var(--color-white);
  background: var(--hero-gradient);
  overflow: hidden;
}

:host .lsr-study-page .hero__content,
:host .lsr-study-page .hero .content {
  max-width: 635px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 60px 0 60px 60px;
  position: relative;
  z-index: 2;
}

:host .lsr-study-page .hero__image,
:host .lsr-study-page .hero > img {
  max-width: 516px;
}

:host .lsr-study-page .hero--inner {
  min-height: 200px;
  position: relative;
  padding-right: 0;
}

:host .lsr-study-page .hero--inner .hero__content,
:host .lsr-study-page .hero--inner .content {
  max-width: 620px;
  padding: 45px 0 45px 60px;
}

:host .lsr-study-page .hero--inner h1 {
  font-size: 36px;
  line-height: 1.12;
}

:host .lsr-study-page .hero--inner .hero__image,
:host .lsr-study-page .hero--inner > img {
  position: absolute;
  z-index: 1;
  right: 84px;
  top: 0;
  width: 494px;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: right top;
  pointer-events: none;
}

:host .lsr-study-page.study .hero--inner .hero__content,
:host .lsr-study-page.study .hero--inner .content {
  padding-left: 52px;
}

:host .lsr-study-page .full-width {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 52px;
}

:host .lsr-study-page .two-columns {
  width: 100%;
  display: flex;
  gap: 60px;
  padding: var(--space-section-y) var(--space-page-x);
}

:host .lsr-study-page .left,
:host .lsr-study-page .right {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

:host .lsr-study-page .dark-green {
  color: var(--color-white);
  background: var(--color-green);
}

:host .lsr-study-page .dark-green h2,
:host .lsr-study-page .dark-green p {
  color: var(--color-white);
}

:host .lsr-study-page .commitment {
  padding: 30px 52px 40px;
}

:host .lsr-study-page .commitment__item {
  max-width: 450px;
  display: flex;
  align-items: center;
  gap: 20px;
}

:host .lsr-study-page .commitment__number {
  width: 100px;
  height: 100px;
  flex: 0 0 100px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--color-white);
  background: var(--color-purple);
  font-size: 60px;
  line-height: 1;
}

:host .lsr-study-page .commitment p {
  font-size: 21px;
  line-height: 1.2;
}

.form-check-label {
    display: inline-block !important;
}


.custom-control-inline {
    display: inline-flex !important;
    align-items: center;
    margin-left: 4px;
}

.custom-control-label {
    display: inline-flex !important;
       position: relative;
    margin-bottom: 0;
    vertical-align: top;
    margin-left: 2px; 
}

@media (max-width: 1024px) {
  :host .lsr-study-page h1 {
    font-size: 48px;
    line-height: 1.12;
  }
}

@media (max-width: 767px) {
  :host .lsr-study-page h1 {
    font-size: 38px;
  }

  :host .lsr-study-page h2 {
    font-size: 26px;
  }

  :host .lsr-study-page p,
  :host .lsr-study-page ul {
    font-size: 16px;
    line-height: 1.35;
  }

  :host .lsr-study-page .hero--inner .hero__image,
  :host .lsr-study-page .hero--inner > img {
    position: static;
    width: 100%;
    height: auto;
    max-width: 100%;
  }

  :host .lsr-study-page .two-columns {
    flex-direction: column;
    gap: 24px;
  }

  :host .lsr-study-page .left,
  :host .lsr-study-page .right {
    width: 100%;
  }
}
/* .primary-button {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  cursor: pointer;
  padding: 16px 34px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: var(--font-main);
  font-size: 15px;
  line-height: 1;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--color-white);
  background: var(--color-green-button);
  transition: color var(--transition), background-color var(--transition), border-color var(--transition);
}

.primary-button:link,
.primary-button:visited {
  color: var(--color-white);
  text-decoration: none;
}

.primary-button:hover, 
.primary-button:focus-visible {
  color: var(--color-white);
  border-color: transparent;
  background: var(--color-purple);
} */`, "",{"version":3,"sources":["webpack://./src/app/shared/participant-study-detail/participant_study_detail.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;gBACc;EACd,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;gBACc;EACd,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;gBACc;EACd,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;EAEE;IACE,eAAe;IACf,cAAc;EAChB;;AAEF;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,+OAA+O;EAC/O,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,4GAA4G;AAC9G;;AAEA;EACE,aAAa;AACf;;AAEA,0EAA0E;AAC1E;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,uGAAuG;AACzG;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gDAAgD;EAChD,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;EASE;AACF;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;;;;GAIG;AACH;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;EAEE;IACE,qBAAqB;EACvB;;AAEF;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA,2CAA2C;AAC3C;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mDAAmD;AACrD;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;OAC5B,kBAAkB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiCG","sourcesContent":[".alert.alert-danger {\r\n  padding: 3px 10px 0 0;\r\n  font-size: 14px;\r\n  line-height: normal;\r\n  background: none;\r\n  border: none;\r\n  color: #a94442;\r\n  text-align: left;\r\n  width: 100%;\r\n  display: inline-block;\r\n  margin: 0;\r\n}\r\n\r\n.form-group-row {\r\n  position: relative;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.ng-invalid.ng-touched {\r\n  border-color: #a94442;\r\n  border-radius: 4px;\r\n}\r\n\r\n.disCHeck {\r\n  display: inline-block;\r\n}\r\n\r\n.disclousureText {\r\n  display: inline-block;\r\n  padding-left: 10px;\r\n  width: 95%;\r\n  vertical-align: top;\r\n}\r\n\r\n.cardheader {\r\n  /* height: 30px;\r\n\twidth: 137px; */\r\n  color: #000000;\r\n  font-family: \"Noto Sans\";\r\n  font-size: 22px;\r\n  line-height: 30px;\r\n}\r\n\r\n.studySummary {\r\n  word-break: break-word;\r\n}\r\n\r\n.cardtext {\r\n  /* height: 30px;\r\n\twidth: 137px; */\r\n  color: #000000;\r\n  font-family: \"Noto Sans\";\r\n  vertical-align: middle;\r\n  /* line-height: 23px; */\r\n  margin: 0 -10px;\r\n  word-break: break-word;\r\n}\r\n\r\n.apply-for-study {\r\n  /* height: 48px;\r\n\twidth: 245px; */\r\n  color: #000000;\r\n  font-family: \"Noto Sans\";\r\n  font-size: 32px;\r\n  font-weight: bold;\r\n  line-height: 48px;\r\n}\r\n\r\n.studyViewCards .cardTitle {\r\n  font-size: 22px;\r\n  border-bottom: 1px solid #cee3ef;\r\n  padding-bottom: 10px;\r\n  padding-left: 15px;\r\n  margin: 0 -10px;\r\n}\r\n\r\n.studyViewCards .card {\r\n  border-bottom: none;\r\n  border-radius: 5px;\r\n  /*border: none;*/\r\n  box-shadow: 0 0 8px 5px rgba(0,49,77,0.2);\r\n}\r\n\r\n/* studyViewCards .card-body {\r\n    height: 295px; \r\n    padding-bottom: 10px;\r\n} */\r\n\r\n.screenDays {\r\n  font-size: 36px;\r\n  height: 15px;\r\n  line-height: 75px;\r\n  /* padding: 0 15px; */\r\n}\r\n\r\n.scheduleWrap .timeList {\r\n  list-style: none;\r\n  padding: 10px 15px;\r\n  border-bottom: 1px solid #ededed;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.scheduleWrap .cardtext .timeList:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.scheduleWrap .dayName {\r\n  font-size: 14px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.scheduleWrap .dayTime {\r\n  font-size: 14px;\r\n  line-height: normal;\r\n  color: #0885ce;\r\n}\r\n\r\n.scheudleDesc {\r\n  line-height: normal;\r\n  padding-top: 8px;\r\n  background-color: #ededed;\r\n  padding: 6px 15px;\r\n  margin-bottom: 0;\r\n  word-break: break-word;\r\n}\r\n\r\n.screenDay, .followDay {\r\n  height: 35px;\r\n  padding: 8px 10px 8px 15px;\r\n  font-size: 14px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.followDay {\r\n  word-break: break-word;\r\n  color: #0885ce;\r\n}\r\n\r\n.screenerWrap, .disclosureForm, .demoGraphicWrap {\r\n  padding: 80px 0;\r\n}\r\n\r\n.demographicsForm {\r\n  font-size: 14px;\r\n}\r\n\r\n  .demographicsForm .label, .demographicsForm .custom-control-label {\r\n    font-size: 14px;\r\n    color: #444444;\r\n  }\r\n\r\n.demographicsForm .custom-control-label .consent-label-html {\r\n  color: inherit;\r\n  font: inherit;\r\n}\r\n\r\n.demographicsForm .consent-group-label,\r\n.demographicsForm .consent-group-label .consent-label-html {\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  color: #444444;\r\n}\r\n\r\n.lsr-form-title,\r\n.lsr-study-form .lsr-form-title {\r\n  margin-bottom: 18px;\r\n  text-align: center;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n.lsr-study-form .lsr-form-text {\r\n  font-size: 14px;\r\n  color: #444444;\r\n}\r\n\r\n.lsr-study-form .lsr-form-text .consent-label-html {\r\n  color: inherit;\r\n  font: inherit;\r\n}\r\n\r\n.lsr-study-form .lsr-consent-group-label,\r\n.lsr-study-form .lsr-consent-group-label .consent-label-html {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 1.45;\r\n  text-align: justify;\r\n  color: #555555;\r\n  gap: 8px;   \r\n}\r\n\r\n.lsr-study-form .lsr-required {\r\n  display: inline-block;\r\n  position: relative;\r\n  top: 6px;\r\n  margin-right: 3px;\r\n  color: var(--color-required);\r\n  font-size: 24px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n}\r\n\r\n.lsr-study-form .lsr-primary-button {\r\n  color: var(--color-white);\r\n  background: var(--color-purple);\r\n}\r\n\r\n.lsr-study-form .lsr-primary-button:hover,\r\n.lsr-study-form .lsr-primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  background: var(--color-purple);\r\n}\r\n\r\n.lsr-study-form .lsr-primary-button:disabled {\r\n  color: var(--color-white) !important;\r\n  background: var(--color-purple) !important;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* LSR custom checkbox appearance for tenantId === '2' */\r\n.lsr-study-form .form-check-input[type=\"checkbox\"] {\r\n  width: 16px;\r\n  height: 16px; \r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  cursor: pointer;\r\n  position: relative;\r\n  flex: 0 0 16px;\r\n  border-radius: 3px;\r\n  border: 1px solid var(--color-border, #bdbfc0);\r\n  background: var(--color-white, #ffffff);\r\n  margin-top: 8px;\r\n}\r\n\r\n.lsr-study-form .form-check-input[type=\"checkbox\"]:checked {\r\n  border-color: var(--color-green, #008073);\r\n  background-color: var(--color-green, #008073);\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: 14px 14px;\r\n}\r\n\r\n.lsr-study-form .form-check-input[type=\"checkbox\"]:checked::after {\r\n  display: none;\r\n}\r\n\r\n.lsr-study-form .lsr-child-consent-row {\r\n  padding: 5px;\r\n}\r\n\r\n/* LSR custom radio appearance for tenantId === '2' */\r\n.lsr-study-form .custom-control-input[type=\"radio\"] {\r\n  width: 16px;\r\n  height: 16px;\r\n  margin: 0 6px 0 0;\r\n  display: inline-block;\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  cursor: pointer;\r\n  position: relative;\r\n  left: auto;\r\n  opacity: 1;\r\n  z-index: 1;\r\n  flex: 0 0 16px;\r\n  align-self: center;\r\n  border-radius: 50%;\r\n  border: 1px solid var(--color-border, #bdbfc0);\r\n  background: var(--color-white, #ffffff);\r\n}\r\n\r\n.lsr-study-form .custom-control.custom-radio {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding-left: 0;\r\n  min-height: unset;\r\n}\r\n\r\n.lsr-study-form .custom-control.custom-radio .custom-control-label {\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: unset;\r\n}\r\n\r\n.lsr-study-form .custom-control-input[type=\"radio\"]:checked {\r\n  border-color: var(--color-green, #008073);\r\n  background: radial-gradient(circle, var(--color-green, #008073) 0 45%, var(--color-white, #ffffff) 46% 100%);\r\n}\r\n\r\n.lsr-study-form .custom-control-input[type=\"radio\"]:checked::after {\r\n  display: none;\r\n}\r\n\r\n/* Hide Bootstrap custom-control-label pseudo-element checkbox duplicate */\r\n.lsr-study-form .custom-control-label::before,\r\n.lsr-study-form .custom-control-label::after {\r\n  display: none;\r\n}\r\n\r\n.lsr-study-form-title {\r\n  margin-bottom: 18px;\r\n  text-align: center;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n:host ::ng-deep .primary-button {\r\n  margin-top: 10px !important;\r\n}\r\n\r\n:host .lsr-study-page .primary-button {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 48px;\r\n  cursor: pointer;\r\n  padding: 16px 34px;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  font-family: var(--font-main);\r\n  font-size: 15px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  text-decoration: none;\r\n  margin-top: 10px;\r\n  color: var(--color-white);\r\n  background: var(--color-green-button);\r\n  transition: color var(--transition), background-color var(--transition), border-color var(--transition);\r\n}\r\n\r\n:host .lsr-study-page .primary-button:link,\r\n:host .lsr-study-page .primary-button:visited {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n:host .lsr-study-page .primary-button:hover,\r\n:host .lsr-study-page .primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  border-color: transparent;\r\n  background: var(--color-purple);\r\n}\r\n\r\n:host .lsr-study-page .primary-button:disabled {\r\n  background: var(--color-green-button) !important;\r\n  color: var(--color-white) !important;\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.aboutTextSec {\r\n  padding: 30px 0;\r\n}\r\n\r\n/*.custWid {\r\n    min-width: 150px;\r\n}\r\n\r\n .custWid-age {\r\n    max-width: 80px;\r\n}\r\n.custWei, .custHei {\r\n    max-width: 95px;\r\n}*/\r\n.custWrist {\r\n  max-width: 200px;\r\n  padding: 0;\r\n}\r\n\r\n.requirements {\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.optionsWrap {\r\n  margin: 0 auto;\r\n}\r\n\r\n.answerOptions > div {\r\n  margin: 0 auto;\r\n}\r\n\r\n.maxW115 {\r\n  max-width: 107px;\r\n}\r\n\r\n.bestTimeToCallWrap .custom-control.custom-checkbox {\r\n  margin-bottom: 7px;\r\n}\r\n\r\n.disclosureForm .container.custom-control {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.screenerWrap .optionsWrap .custom-control.custom-radio {\r\n  margin-bottom: 7px;\r\n}\r\n\r\np-calendar {\r\n  width: 100%;\r\n}\r\n/* @media (min-width: 768px) {\r\n    .perDiv {\r\n        width: auto;\r\n    }\r\n} */\r\n.detailForm label {\r\n  margin-bottom: 1px;\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n}\r\n\r\n.normalFont {\r\n  font-weight: normal;\r\n  color: #000000;\r\n}\r\n\r\n.compenHead {\r\n  padding-bottom: 6px;\r\n}\r\n\r\n.invalidInput, .invalidInput:focus {\r\n  border-color: #a94442;\r\n}\r\n\r\n.dobInput {\r\n  left: 0;\r\n  font-variant-numeric: lining-nums tabular-nums;\r\n  font-feature-settings: \"lnum\" 1, \"tnum\" 1;\r\n}\r\n\r\n.dCircle {\r\n  border-radius: 250px;\r\n  display: inline-block;\r\n  width: 85px;\r\n  height: 85px;\r\n  line-height: 85px;\r\n  text-align: center;\r\n  color: #ffffff;\r\n}\r\n\r\n.screening {\r\n  background-color: #005586;\r\n}\r\n\r\n.dcd {\r\n  background-color: #288cc6;\r\n}\r\n\r\n.followUp {\r\n  background-color: #59baf3;\r\n}\r\n\r\n#commitment-table tr td {\r\n  padding: 10px 15px;\r\n  border-bottom: 1px solid #ededed;\r\n}\r\n\r\n#studySchedule-table tr td {\r\n  border-bottom: 1px solid #ededed;\r\n}\r\n\r\n#commitment-table tr:last-child td, #studySchedule-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.marg {\r\n  margin: 0 -10px;\r\n}\r\n\r\n#studySchedule-table.table thead > tr > th {\r\n  height: auto;\r\n  padding: 8px 15px;\r\n  background-color: #ededed;\r\n}\r\n\r\n.backBtn {\r\n  border: 1px solid #d9d9d9 !important;\r\n  height: 30px;\r\n  width: 102px;\r\n  background-color: #fff;\r\n  margin-left: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.custom-checkbox {\r\n  display: inline-block;\r\n  width: 20px;\r\n  height: 20px;\r\n  margin: 5px;\r\n  border: 2px solid #000;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n.backBtn:hover {\r\n  color: #FFFFFF;\r\n  border: 1px solid #0094ff;\r\n  background-color: #0094ff;\r\n}\r\n\r\ndiv[name=\"contact\"] {\r\n  width: 100%;\r\n  text-align: justify;\r\n  margin: 3px auto;\r\n}\r\n\r\ndiv[name=\"form-start\"] {\r\n  margin-top: 25px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .custWrist {\r\n    max-width: 100%;\r\n    padding: 0 15px;\r\n  }\r\n\r\n  .perDiv {\r\n    margin-bottom: 8px;\r\n    padding-bottom: 5px;\r\n  }\r\n\r\n  .p-25 {\r\n    padding: 0 25px\r\n  }\r\n\r\n  .genderWrap {\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .studyViewCards .col-sm-12 {\r\n    padding-left: 0;\r\n  }\r\n\r\n  .demoGraphicWrap {\r\n    padding: 40px 0;\r\n  }\r\n\r\n  .blueBox {\r\n    padding: 40px 20px 20px;\r\n  }\r\n}\r\n\r\nbutton[name=continueBtn]:disabled:not(.primary-button) {\r\n  background-color: #2cb00e;\r\n  color: #fff;\r\n}\r\n\r\n.listPosInside {\r\n  list-style-type: none;\r\n  padding-left: 0;\r\n}\r\n\r\n  .listPosInside li {\r\n    list-style-type: none;\r\n  }\r\n\r\n.name-row .form-group {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .name-row > div {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n}\r\n\r\n#txtweight {\r\n  margin-left: 16px;\r\n  max-width: 90%;\r\n}\r\n\r\n.lsr-study-form .weight-field,\r\n.lsr-study-form .bmi-field {\r\n  display: flex;\r\n  flex-direction: column;  \r\n}\r\n\r\n.lsr-study-form .weight-field .label,\r\n.lsr-study-form .bmi-field .label {\r\n  min-height: 24px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.lsr-study-form .weight-field .form-control,\r\n.lsr-study-form .bmi-field .form-control {\r\n  margin-top: 0;\r\n  font-variant-numeric: lining-nums tabular-nums;\r\n  font-feature-settings: \"lnum\" 1, \"tnum\" 1;\r\n}\r\n\r\n/* Tenant 2 (LSR) study-page local styles */\r\n:host .lsr-study-page {\r\n  font-family: var(--font-main);\r\n  color: var(--color-black);\r\n}\r\n\r\n:host .lsr-study-page h1,\r\n:host .lsr-study-page h2,\r\n:host .lsr-study-page h3,\r\n:host .lsr-study-page p,\r\n:host .lsr-study-page ul {\r\n  margin: 0;\r\n}\r\n\r\n:host .lsr-study-page h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n}\r\n\r\n:host .lsr-study-page h2 {\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n:host .lsr-study-page p,\r\n:host .lsr-study-page ul {\r\n  font-size: 18px;\r\n  line-height: 1.18;\r\n}\r\n\r\n:host .lsr-study-page ul {\r\n  max-width: 563px;\r\n  padding-left: 24px;\r\n}\r\n\r\n:host .lsr-study-page li::marker {\r\n  font-size: 10px;\r\n}\r\n\r\n:host .lsr-study-page a {\r\n  color: inherit;\r\n}\r\n\r\n:host .lsr-study-page p a {\r\n  color: var(--color-green);\r\n}\r\n\r\n:host .lsr-study-page img {\r\n  display: block;\r\n  max-width: 100%;\r\n  height: auto;\r\n  border: 0;\r\n}\r\n\r\n:host .lsr-study-page section {\r\n  scroll-margin-top: 120px;\r\n}\r\n\r\n:host .lsr-study-page .hero {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 60px;\r\n  padding-right: 76px;\r\n  color: var(--color-white);\r\n  background: var(--hero-gradient);\r\n  overflow: hidden;\r\n}\r\n\r\n:host .lsr-study-page .hero__content,\r\n:host .lsr-study-page .hero .content {\r\n  max-width: 635px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n  padding: 60px 0 60px 60px;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n:host .lsr-study-page .hero__image,\r\n:host .lsr-study-page .hero > img {\r\n  max-width: 516px;\r\n}\r\n\r\n:host .lsr-study-page .hero--inner {\r\n  min-height: 200px;\r\n  position: relative;\r\n  padding-right: 0;\r\n}\r\n\r\n:host .lsr-study-page .hero--inner .hero__content,\r\n:host .lsr-study-page .hero--inner .content {\r\n  max-width: 620px;\r\n  padding: 45px 0 45px 60px;\r\n}\r\n\r\n:host .lsr-study-page .hero--inner h1 {\r\n  font-size: 36px;\r\n  line-height: 1.12;\r\n}\r\n\r\n:host .lsr-study-page .hero--inner .hero__image,\r\n:host .lsr-study-page .hero--inner > img {\r\n  position: absolute;\r\n  z-index: 1;\r\n  right: 84px;\r\n  top: 0;\r\n  width: 494px;\r\n  height: 100%;\r\n  max-width: none;\r\n  object-fit: cover;\r\n  object-position: right top;\r\n  pointer-events: none;\r\n}\r\n\r\n:host .lsr-study-page.study .hero--inner .hero__content,\r\n:host .lsr-study-page.study .hero--inner .content {\r\n  padding-left: 52px;\r\n}\r\n\r\n:host .lsr-study-page .full-width {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  padding: 52px;\r\n}\r\n\r\n:host .lsr-study-page .two-columns {\r\n  width: 100%;\r\n  display: flex;\r\n  gap: 60px;\r\n  padding: var(--space-section-y) var(--space-page-x);\r\n}\r\n\r\n:host .lsr-study-page .left,\r\n:host .lsr-study-page .right {\r\n  width: 50%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 28px;\r\n}\r\n\r\n:host .lsr-study-page .dark-green {\r\n  color: var(--color-white);\r\n  background: var(--color-green);\r\n}\r\n\r\n:host .lsr-study-page .dark-green h2,\r\n:host .lsr-study-page .dark-green p {\r\n  color: var(--color-white);\r\n}\r\n\r\n:host .lsr-study-page .commitment {\r\n  padding: 30px 52px 40px;\r\n}\r\n\r\n:host .lsr-study-page .commitment__item {\r\n  max-width: 450px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n:host .lsr-study-page .commitment__number {\r\n  width: 100px;\r\n  height: 100px;\r\n  flex: 0 0 100px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  color: var(--color-white);\r\n  background: var(--color-purple);\r\n  font-size: 60px;\r\n  line-height: 1;\r\n}\r\n\r\n:host .lsr-study-page .commitment p {\r\n  font-size: 21px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.form-check-label {\r\n    display: inline-block !important;\r\n}\r\n\r\n\r\n.custom-control-inline {\r\n    display: inline-flex !important;\r\n    align-items: center;\r\n    margin-left: 4px;\r\n}\r\n\r\n.custom-control-label {\r\n    display: inline-flex !important;\r\n       position: relative;\r\n    margin-bottom: 0;\r\n    vertical-align: top;\r\n    margin-left: 2px; \r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  :host .lsr-study-page h1 {\r\n    font-size: 48px;\r\n    line-height: 1.12;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  :host .lsr-study-page h1 {\r\n    font-size: 38px;\r\n  }\r\n\r\n  :host .lsr-study-page h2 {\r\n    font-size: 26px;\r\n  }\r\n\r\n  :host .lsr-study-page p,\r\n  :host .lsr-study-page ul {\r\n    font-size: 16px;\r\n    line-height: 1.35;\r\n  }\r\n\r\n  :host .lsr-study-page .hero--inner .hero__image,\r\n  :host .lsr-study-page .hero--inner > img {\r\n    position: static;\r\n    width: 100%;\r\n    height: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  :host .lsr-study-page .two-columns {\r\n    flex-direction: column;\r\n    gap: 24px;\r\n  }\r\n\r\n  :host .lsr-study-page .left,\r\n  :host .lsr-study-page .right {\r\n    width: 100%;\r\n  }\r\n}\r\n/* .primary-button {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 48px;\r\n  cursor: pointer;\r\n  padding: 16px 34px;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  font-family: var(--font-main);\r\n  font-size: 15px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  text-decoration: none;\r\n  color: var(--color-white);\r\n  background: var(--color-green-button);\r\n  transition: color var(--transition), background-color var(--transition), border-color var(--transition);\r\n}\r\n\r\n.primary-button:link,\r\n.primary-button:visited {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n.primary-button:hover, \r\n.primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  border-color: transparent;\r\n  background: var(--color-purple);\r\n} */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
